import $ from 'jquery';
import Backbone from 'backbone';
import 'jquery.cookie';
import ajaxrequest from 'wg-ajaxrequest';
import { isArray } from 'underscore';

var CSRF_TOKEN,
    ajax,
    enableCsrfToken;


Backbone.enableCsrfToken = function(appid) {
    var _appid;

    if (CSRF_TOKEN || CSRF_TOKEN === false) {
        return CSRF_TOKEN;
    }
    window.Settings = window.Settings || {};
    if (window.Settings.CSRF_TOKEN) {
        CSRF_TOKEN = window.Settings.CSRF_TOKEN;
        return CSRF_TOKEN;
    }
    _appid = appid || window.Settings.appid || false;
    if (!_appid) {
        CSRF_TOKEN = false;
        return CSRF_TOKEN;
    }
    CSRF_TOKEN = window.Settings.CSRF_TOKEN = $.cookie(_appid + '_csrftoken');
    return CSRF_TOKEN;
};

Backbone.ajax = function(params) {
  Backbone.enableCsrfToken();
  let headers = {
      'X-Requested-With': 'XMLHttpRequest'
  };
  let dataParams = params.data;
  if (params.type === 'POST') {
      headers = {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          'X-Requested-With': 'XMLHttpRequest'
      };

      const submitData = new URLSearchParams();
      Object.keys(dataParams).forEach(key => {
        if (dataParams[key]) {
          if (isArray(dataParams[key])) {
            dataParams[key].forEach(value => submitData.append(key, value));
          } else {
            submitData.append(key, dataParams[key]);
          }
        }
      });
      dataParams = submitData;
  }
  const submitParams = Object.assign({}, params, {
      headers,
      method: params.type.toLowerCase()
  });
  return ajaxrequest.submit(dataParams, submitParams);
};



// WEBPACK FOOTER //
// ./~/wgnet-awesomejs/base/wg_ajax_extention.js